import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

import { AuthHeaders } from '../../../models/auth-headers';
import { requiredHeaders } from '../../../models/required-headers';
import { dateToISOStringPreprocessor } from '../../../utils/date-to-iso-string-preprocessor';
import { ignoreData } from '../../../utils/ignore-data';
import { parseRequestSchema } from '../../../utils/parse-request-schema';
import { authwsEnvironment } from '../authws-environment';
import { accountProductRelationshipSchema } from '../schemas/account-product-relationship.schema';

const requestSchema = accountProductRelationshipSchema
  .omit({
    manageOwnAPIKeys: true,
    phone: true,
  })
  .partial()
  .required({
    accountState: true,
  })
  .extend({
    product: z.string().min(1),
  });

/**
 * Removes a list of Trimble Maps applications from an account
 * @param accountId Id of Account to remove application assignments
 * @param products Array of Trimble Maps applications to unassign
 */
export function deleteProductsMultipleAccounts(
  this: unknown,
  accountId: number,
  products: z.infer<typeof requestSchema>[]
) {
  return fromFetch(
    new Request(
      `${
        authwsEnvironment.resolve(this).productsMultipleAccountsUrl
      }/${encodeURIComponent(accountId)}`,
      {
        method: 'DELETE',
        headers: {
          ...requiredHeaders,
          ...new AuthHeaders(),
        },
        body: parseRequestSchema(
          z.array(
            requestSchema.extend({
              expirationDate: dateToISOStringPreprocessor()
                .nullable()
                .optional(),
            })
          ),
          products
        ),
      }
    )
  ).pipe(ignoreData());
}
